export default {
  plans: {
    pricing: {
      switch: {
        monthly: 'Monthly',
        annually: 'Annually',
      },
      discount: 'Save 20% with annual subscription',
      description: "And we're not going to stop making goods for you",
    },
    button: {
      from: 'Valid from {{date}}',
      till: 'Valid till {{date}}',
      current: 'Current',
      choose: 'Choose',
      confirm: 'Got it!',
      discount: 'Get Discount',
      cancel: 'Cancel anyway',
      stay: 'Stay where I am',
      continue: 'Continue',
      back: 'Back',
      keepPlan: 'Keep the plan',
      downgrade: 'Downgrade',
    },
    downgrade: {
      header: {
        changePlan: 'Change your current plan?',
        feedback: {
          mobile: 'Leave feedback',
          desktop: 'Leave feedback to help us become better',
        },
      },

      changePlan: {
        title: 'You’ll permanently loose:',
      },
      feedback: {
        title: 'Why do you want to cancel your subscription?',
      },

      title: 'Downgrade your plan',
      step1: {
        title: 'We are sorry about your decision. Why do you want to downgrade?',
        textFieldLabel: 'Your detailed answer is important to us',
      },
      step2: {
        title: 'Do you still want to downgrade?',
        subtitle1: 'After you downgrade you’ll no longer have full access to your favorite features:',
      },
      step3: {
        title: 'Downgrade your plan',
        subtitle1: 'We have a special offer for you!',
        subtitle2:
          'hubmee cares about you, so you have an exclusive opportunity to continue to enjoy hubmee.',
        subtitle3: 'One time discount for the next month',
        discount: 'Get 50%',
      },
      step4: {
        title: 'Great choice!',
        subtitle1: 'Thank you for your trust',
      },
      step5: {
        title: 'You can get back any time',
        subtitle1: 'Your data will be waiting for you in {{subscription}}',
        subtitle2: 'So you can continue where you were. Now enjoy ',
        subtitle3: 'Please note, you still have access to the {{subscription}} till your expiration date',
        starter: 'Begin with Starter!',
      },
    },
    promocode: {
      title: 'Do you have a promo code ?',
      discount: 'Your discount is {{discount}}',
    },
    userChoice: 'User’s Choice',
    selected: 'Selected',
    features: {
      autoReminders: 'Auto reminders',
      tasksAndEvents: 'Tasks and events full access',
      prioritizing: 'Prioritizing',
      dueDates: 'Due dates',
      progressTracking: 'Progress tracking',
      hubsFullAccess: 'Hubs full access',
      autoScheduledPayments: 'Auto-scheduled payments',
    },
    plansModal: {
      title: 'Compare plans and find yours',
      title1: 'title title 1',
      gold: 'Reach new level \nof organization',
      platinum: 'Automate your routine \nto the fullest',
    },
  },
  chooseHub: {
    choose: 'If you wanna get the most out of hubmee, get',
    hub: 'hub',
    forYou: 'that’s right for you',
  },
  platinumPlan: 'Platinum plan',
  silver: 'Silver',
  gold: 'Gold ',
  platinum: 'Platinum',

  table: {
    header: {
      organizer: {
        title: 'Organizer',
        description: 'Automate your routine',
      },
      hubs: {
        title: 'Hubs',
        description: 'Quick access to vital information',
      },
      communication: {
        title: 'Communication',
        description: 'Stay connected anytime & anywhere with every hubmee plan',
      },
    },
    communication: {
      chat: {
        title: 'Chat',
        description: 'Improve your communication with loved ones in personal and group chats.',
      },
      network: {
        title: 'Network',
        description: 'Divide work from personal life by giving people different roles in your Network.',
      },
      contacts: {
        title: 'Contacts',
        description:
          'Add here contact information about your lawyer, therapist and hairdresser for quick access.',
      },
      notifications: {
        title: 'Notifications',
        description:
          'Receive only important  messages about new tasks, invitations to events and changes in your app.',
      },
      reminders: {
        title: 'Reminders',
        description: "We won't let you forget about any due date, event, payments or somebody's birthday.",
      },
    },
    leftColumnItems: {
      garage: 'Garage',
      profile: 'Profile',
      budget: 'Budget',
      cloud: 'Cloud',
      pets: 'Pets',
      education: 'Education',
      work: 'Work',
      health: 'Health',
      property: 'Property',
      todo: 'To-Do',
      journalCalendar: 'Journal & Calendar',
      tasks: 'Tasks',
      backlog: 'Backlog',
    },
    description: {
      createChecklists: 'create checklists',
      createTasks: 'create tasks',
      customize: 'customize',
      duplicate: 'duplicate',
      share: 'share',
      convertToTask: 'convert to task',
      dueDate: 'due date',
      limitedEventsTasks: 'limited access to events and tasks',
      addNotesChecklists: 'add notes and checklists',
      comment: 'comment',
      changeStatus: 'change status',
      createEventsTasks: 'create events and tasks',
      trackProgress: 'track progress',
      priority: 'priority',
      autoScheduledPayments: 'auto-scheduled payments',
      generalInformation: 'general information',
      gallery: 'gallery',
      registrations: 'vehicle and LP registration',
      vehicleInsurance: 'vehicle insurance',
      notifyButton: 'notify me button',
      contacts: 'contacts',
      appearance: 'appearance',
      bodyArt: 'body art',
    },
    comingSoon: {
      description: 'This section is coming soon...',
    },
  },
};
